// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { create } from "@bufbuild/protobuf"
import { showSnackBar } from "../../snackbar/actions"
import * as Actions from "../actions"
import * as Slice from "../slice"
import { executor, Init, timesheetFieldService } from "../../../app/rpc"
import {
  BatchGetTimesheetFieldConfigsRequestSchema,
  BatchGetTimesheetFieldConfigsResponse,
} from "../../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

type BatchGetTimesheetFieldConfigsRpc = (request: Init<typeof BatchGetTimesheetFieldConfigsRequestSchema>) => Observable<BatchGetTimesheetFieldConfigsResponse>

export const batchGetTimesheetFieldConfigs = (batchGetTimesheetFieldConfigsRpc: BatchGetTimesheetFieldConfigsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.batchGetTimesheetFieldConfigs.match),
      map(action => action.payload),
      mergeMap(request => 
        batchGetTimesheetFieldConfigsRpc(request).pipe(
          map(response => Slice.setTimesheetFieldConfigs({
            configs: response.timesheetFieldConfigs,
            siteId: request?.siteId ?? "",
          })),
          catchError(() => of(showSnackBar({
            message: t({
              id: "msg_batch_get_timesheet_field_configs_failed",
              message: "Failed to load timesheet field details. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
            }),
            messageType: "ERROR",
          }))),
        )
      ),
    )

const batchGetTimesheetFieldConfigsRpc = (request: Init<typeof BatchGetTimesheetFieldConfigsRequestSchema>): Observable<BatchGetTimesheetFieldConfigsResponse> =>
  executor(() => timesheetFieldService.batchGetTimesheetFieldConfigs(create(BatchGetTimesheetFieldConfigsRequestSchema, request)))

export default batchGetTimesheetFieldConfigs(batchGetTimesheetFieldConfigsRpc)
